import React, { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { useQuery } from 'react-query'

import Header, { HeaderActions } from "../shared/Header.js"
import Spinner from "../shared/Spinner.js";

import { useFromQueryString, toQueryString, TIME_ZONE } from "../../utils.js";
import { FilterMenu } from '../shared/Filters.js';
import Pagination from "../shared/Pagination.js";

import { Container } from '../layout/AppLayout.js';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import AlertConnectionTable from "../alerts/AlertConnectionTable.js";
import AlertSubmenu from "./AlertSubmenu.js";
import { isAllowed } from "../shared/FeatureChecker.js";
import { CurrentUserContext } from "../../App.js";

export default function AlertConnectionListPage() {
  const queryString = useFromQueryString();
  const navigate = useNavigate();
  const currentUser = useContext(CurrentUserContext)

  const [currentFilters, setCurrentFilters] = useState({
    page: parseInt(queryString.page) || 1,
    limit: parseInt(queryString.limit) || 100,
    ZoneId: (queryString.ZoneId) || '',
    sort: "date,desc",
    LiveStatus: (queryString.LiveStatus) || '',
    tz: TIME_ZONE,
    DoorId: (queryString.DoorId) || ''
  });

  useEffect(() => {
    if(currentUser){
      const allowed= isAllowed({user: currentUser,feature: "LIST_STATE_ALERTS"})
      if (!allowed){
        navigate('/error?error=403')
      }
    }

  },[currentUser])


  const query = useQuery(`alertstate/live?${toQueryString(currentFilters)}`, {
    keepPreviousData: true,
  })

  useEffect(()=>{
    setCurrentFilters(prevFilters => ({
      ...prevFilters,
      page: 1
    }));
  },[queryString.LiveStatus,queryString.ZoneId,queryString.DoorId])

  useEffect(() => {
    navigate("?" + toQueryString(currentFilters), { replace: true });
  }, [currentFilters]);

  return (
    <Container>
      <Row>
        <Header title="Alertas" items={[
          { label: "Listado de alertas" }
        ]}>
          <HeaderActions>
          </HeaderActions>
        </Header>
      </Row>
      <div className="row">
        <AlertSubmenu filters={currentFilters}/>
      </div>

      <Row className="mb-2">
        <FilterMenu
          currentFilters={currentFilters}
          onChange={filters => setCurrentFilters(prev => ({ ...prev, ...filters }))}
          
        />
      </Row>

      <Row className="mb-2">
        <Col className="col-12">
          {
            query.isLoading ?
              <div className="text-center my-4 py-4">
                <Spinner />
              </div>
            :
              <AlertConnectionTable alerts={query.data && query.data.result || []} />
          }
        </Col>
      </Row>

      <Row className="mt-3">
        <Pagination
          pagination={query.data && query.data.pagination}
          isLoading={query.isFetching}
          onChange={page => setCurrentFilters(prev => ({ ...prev, page }))}
        />
      </Row>
    </Container>
  );
}
